import React from 'react';
import { compose, withHandlers, lifecycle, withStateHandlers } from 'recompose';
import { connect } from 'react-redux';
import {
  generatePageStructure,
  nameById,
} from '@mm/state/helpers/filterable-select-helpers';
import Select from '../../../../../common/components/FilterableSelect/FilterableSelect';
import MessengerAdCRUDActions from '@mm/state/actions/MessengerAdCRUDActions';
import MessengerPluginBlock from '../../../common/components/MessengerPluginBlock/MessengerPluginBlock';
import './MessengerAdDetail.scss';

const initialState = ({ ad, pages }) => {
  let selectedPage = null;
  if (ad && pages) {
    const { pageId } = ad;
    selectedPage = pages.find(p => p.id === pageId);
  }

  return {
    selectedPage,
  };
};

const stateUpdaters = {
  setSelectedPage: () => selectedPage => ({ selectedPage }),
};

function componentDidUpdate() {
  const { ad, pages, setSelectedPage } = this.props;

  if (ad && pages) {
    const { pageId } = ad;
    setSelectedPage(pages.find(p => p.id === pageId));
  }
}

const PageSelectorBase = props => {
  const { pages, selectedPage, onSelectPage, pageGroups } = props;
  return (
    <div className="ad-details__input-container">
      <div className="ad-details__page-select-container">
        <div className="ad-details__field-title">Dialogue</div>
        <Select
          outerValue={nameById(selectedPage && selectedPage.id, pages)}
          onChange={onSelectPage}
          suggestions={generatePageStructure(pages, pageGroups)}
        />
      </div>
      <MessengerPluginBlock selectedPage={selectedPage} />
    </div>
  );
};

const onSelectPage =
  ({ pages, setSelectedPage, updateAd, chatbotId, ad }) =>
  e => {
    const selectedPage = pages.find(item => item.id === Number(e));
    setSelectedPage(selectedPage);
    const newAd = Object.assign({}, ad, { pageId: selectedPage.id });
    updateAd(chatbotId, newAd);
  };

const mapStateToProps = state => ({
  pages: state.page.dropdown,
  pageGroups: state.pageGroup.entities,
});

const mapDispatchToProps = dispatch => ({
  updateAd: (botId, entity) =>
    dispatch(MessengerAdCRUDActions.updateLegacy(botId, entity)),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(initialState, stateUpdaters),
  withHandlers({ onSelectPage }),
  lifecycle({ componentDidUpdate }),
);

export default enhance(PageSelectorBase);
